import { useForm, useWatch } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod/v4";
import FormInputText from "../shared/FormInputText";
import { useState } from "react";
import FormSelect from "../shared/FormSelect";
import { fetchCreateTicket } from "../../utils/apiUtils";
import ReactJson from "react-json-view";
import { queryClient } from "../../App";

const CreateTicket = () => {
    const [ticketId, setTicketId] = useState()
    const [errorMessage, setErrorMessage] = useState()
    const {
        control,
        register,
        formState: { errors, isValid, isDirty, dirtyFields, isSubmitting, isSubmitSuccessful },
        getValues,
        handleSubmit,
    } = useForm({
        resolver: zodResolver(
            z.object({
                title: z.string().min(1, 'Title is required'),
                desc: z.string().min(1, 'Description is required'),
                type: z.object({
                    label: z.string().min(1, 'Type is required'),
                    value: z.string().min(1, 'Title is required')
                }),
                prority: z.object({
                    label: z.string().min(1, 'Type is required'),
                    value: z.string().min(1, 'Title is required')
                })
            })
        ),
        // defaultValues: {
        //     email: ''
        // },
        mode: "onSubmit"
    });

    const onSubmit = async (values) => {
        setErrorMessage()

        try {
            console.log({ values })
            const result = await fetchCreateTicket({
                ...values,
                type: values.type.value,
                prority: values.prority.value,

            })
            setTicketId(result)

            queryClient.invalidateQueries({ queryKey: ['backlog', ''] })
        } catch (err) {
            setErrorMessage(err.message)
        }


    }

    return (
        <div style={{ width: '100%', padding: '1rem' }}>
            <p className="title">Create Ticket</p>
            <p className="sub-title">Enhancements and bug reporting</p>


            {ticketId ? <>
                <ReactJson
                    style={{ padding: "1rem", }}
                    src={ticketId || ""}
                    name={false}
                    collapsed={1}
                    collapseStringsAfterLength={150}
                    displayDataTypes={false}
                    displayObjectSize={false}
                    sortKeys={false}
                />

            </>
                :
                <form onSubmit={handleSubmit(onSubmit)} className="form" style={{ paddingTop: '3rem' }}>

                    <FormSelect
                        label={'Type'}
                        name={'type'}
                        control={control}
                        options={[{ value: 'bug', label: '🐞 Bug' }, { value: 'enhancement', label: '⚙️ Enhancement' }]}
                        errors={errors}
                        placeholder="Select..."
                        style={{ width: '30%' }}
                    />
                    <div style={{ display: 'flex', gap: '1rem' }}>


                        <FormInputText label={'Title'} name="title" register={register} errors={errors} placeholder="Title..." />
                        <FormSelect
                            label={'Prority'}
                            name={'prority'}
                            control={control}
                            options={[{ value: 'high', label: 'High' }, { value: 'medium', label: 'Medium' }, { value: 'low', label: 'Low' }]}
                            errors={errors}
                            placeholder="Select..."
                            style={{ width: '30%' }}
                        />


                    </div>


                    <FormInputText type={'textarea'} label={'Description'} name="desc" register={register} errors={errors} />
                    {errorMessage && <p className="danger" style={{ padding: '0rem 0rem 2rem 0rem' }}>{errorMessage}</p>}

                    {isSubmitting ? <div className="loader" /> : <input
                        className="btn"
                        type="submit"
                        disabled={Object.keys(dirtyFields).length && !isValid}
                        value={'Create'} />}


                </form>
            }



        </div>
    )
}

export default CreateTicket